/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import * as React from "react"
import PropTypes from "prop-types"
import "../css/main.css"
import UniversalHeader from "@airasia/phoenix-widgets/widgets/UniversalHeader";
import UNIVERSAL_HEADER_DATA from "../data/header";
import UNIVERSAL_FOOTER_DATA from "../data/footer";
import UniversalFooter from "@airasia/phoenix-widgets/widgets/UniversalFooter";
import HeroBanner from "@airasia/phoenix-widgets/widgets/HeroBanner";
import Theme from "@airasia/phoenix-components/components/Theme";
import styled from "styled-components";
import Seo from "./seo";

import WebVitalRUM from "@airasia/phoenix-components/components/WebVitalRUM";
import { fireGtmEvent } from "../utils/functions";


const BannerWrapper = styled.div`
  margin-bottom: 16px;

  @media only screen and (min-width: 720px) {
    margin-bottom: 32px;
  }
`


const Wrapper = styled.div`
  max-width: 625px;
  margin: 0px 16px 24px;

  @media only screen and (min-width: 720px) {
    width: 90%;
    max-width: 976px;
    margin: 0px auto 48px;
  }

  @media only screen and (min-width: 1025px) {
    width: 90%;
    max-width: 1224px;
    margin: 0px auto 48px;
  }
`;

const MobileContainer = styled.div`
  @media only screen and (min-width: 768px) {
    display: none;
  }
`

const DesktopContainer = styled.div`
  @media only screen and (max-width: 768px) {
    display: none;
  }
`

const Copyright = styled.div`
  display:flex;
  margin-top:5%;
  `


const Layout = ({pageData, children}) => {
    const {
        pageTitle,
        url,
        heroBanner,
    } = pageData;

    const [innerWidth, setInnerWidth] = React.useState();

    const onWindowResize = () => {
        if (typeof window !== undefined) {
            setInnerWidth(window.innerWidth);
        }
    };

    React.useEffect(() => {
        onWindowResize();

        window.addEventListener("resize", onWindowResize);
        return () => window.removeEventListener("resize", onWindowResize);
    }, []);

  return (
    <Theme theme="AIRASIA_CLASSIC">
        <Seo pageTitle={pageTitle} url={url}/>
        <WebVitalRUM fireGtm={fireGtmEvent}/>
        <MobileContainer>
          <UniversalHeader
            accessible={true}
            color="greyDarker"
            currency="MYR"
            data={UNIVERSAL_HEADER_DATA}
            environment="production"
            locale="en-gb"
            viewport="mobile"
          />
          {heroBanner && (
            <BannerWrapper>
              <HeroBanner
                device="mobile"
                height="200px"
                selectedBanner={0}
                width="100%"
                bannerDetails={heroBanner}
                accessible
                fireGtm={fireGtmEvent}
              />
            </BannerWrapper>
          )}
        </MobileContainer>
        <DesktopContainer>
          <UniversalHeader
            accessible={true}
            color="greyDarker"
            currency="MYR"
            data={UNIVERSAL_HEADER_DATA}
            environment="production"
            locale="en-gb"
            viewport="desktop"
          />
          {heroBanner && (
            <BannerWrapper>
              <HeroBanner
                device="desktop"
                height="280px"
                selectedBanner={0}
                width="100%"
                bannerDetails={heroBanner}
                accessible
                fireGtm={fireGtmEvent}
              />
            </BannerWrapper>
          )}
        </DesktopContainer>
        <Wrapper>
            {children}
        </Wrapper>
        {innerWidth <= 768 ? (
            <UniversalFooter viewport="mobile" data={UNIVERSAL_FOOTER_DATA}/>
        ) : (
            <UniversalFooter viewport="desktop" data={UNIVERSAL_FOOTER_DATA}/>
        )}
    </Theme>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
